import React from "react";

interface WizardLayoutProps {
  formContent: React.ReactNode;
  illustrationContent: React.ReactNode;
  stepTitle: string;
  stepDescription: string;
}

export function WizardLayout({
  formContent,
  illustrationContent,
  stepTitle,
  stepDescription,
}: WizardLayoutProps) {
  return (
    <div className="flex flex-col md:flex-row flex-1 min-h-0 md:min-h-[500px]">
      {/* Form - 2/3 on desktop, full on mobile */}
      <div className="w-full md:w-2/3 p-6 overflow-y-auto">
        {formContent}
      </div>
      {/* Illustration - 1/3 on desktop, hidden on mobile */}
      <div className="hidden md:flex md:w-1/3 bg-secondary flex-col p-6 border-l border-accent">
        {/* Header - top aligned */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-foreground">
            {stepTitle}
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            {stepDescription}
          </p>
        </div>
        {/* Illustration - centered in remaining space */}
        <div className="flex-1 flex items-center justify-center">
          {illustrationContent}
        </div>
      </div>
    </div>
  );
}
